import { useNavigate } from 'react-router-dom';
import ServiceButton from '../components/ui/ServiceButton';
import bgSpeed from '../assets/images/not-found.png';

function NotFound() {
  const navigate = useNavigate();

  return (
    <section className="relative h-screen overflow-hidden flex items-center">
      {/* Background image */}
      <img
        src={bgSpeed}
        alt="Decorative background"
        className="absolute inset-0 w-full h-full object-cover"
      />

     
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2">
        <div className="flex flex-col justify-center space-y-6 max-w-xl py-12">
          <h1 className="special-header text-[200px]  font-bold text-[#F55109]">404</h1>
          <h2 className="special-header text-7xl sm:text-7xl font-bold text-white">Page Not Found</h2>
          <p className="text-gray-300 text-lg">
            Sorry, the page you’re looking for does not exist or has been moved. Please go back to the Home page.
          </p>
          <div>
          <ServiceButton
                title="Go Back"
                variant="white"
                onClick={() => navigate('/')}
                className="mt-4"
              />
          </div>
        </div>
      </div>
    </section>
  );
}

export default NotFound;
